import React from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';

import Popup from "../common/Popup";
import PopupTrigger from "../common/PopupTrigger";
import { initial } from '../../redux/errorState';
import { useEffect } from "react";
import { mathpidLogAPICall } from "../../redux/logData";
import { TYPE } from "../../constant";
import { appAmplitudeEventFunc } from "../../utils/appEventFunc";

const ErrorPopup = () => {
  
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const deviceInfo = useSelector( state => state.deviceInfo );
  const errorMsg = useSelector( state => state.errorState.errorMessage );
  const errorCode = useSelector(state => state.errorState.errorCode );
  const errorFunc = useSelector( state => state.errorState.errorFunc );
  

  useEffect(() => {
    if (errorCode === 'E000018' || errorCode === TYPE.LOGIN.DUPLICATE || errorCode === TYPE.LOGIN.EXPIRES) {
      // 로그 data set 후 API Call
      dispatch(mathpidLogAPICall({
        verbId: 'accessed',
        objectId: 'screen',
        screenVersion: 'screenCode',
        screenCode: 'scr_0009_0003',
      }));
      appAmplitudeEventFunc(null, 'regenAmplitude')
    }

  }, [errorCode]);



  const onConfirm = () => {
    if (errorFunc) errorFunc({
      deviceInfo,
      history
    });
    dispatch(initial());
  }

  return (
    errorMsg
      ? (
        <PopupTrigger className={`${deviceInfo.type} `}>
          <Popup
            buttonLabel={[t("front_message.msg025")]}
            onConfirm={onConfirm}
          >
            <p className="lc-alert_txt m-fw-normal"
              dangerouslySetInnerHTML={{ __html: errorMsg }}
            />
          </Popup>
        </PopupTrigger>
      )
      : null
  );

};

export default ErrorPopup;
